import { yupResolver } from '@hookform/resolvers/yup';
import { IPersonalizationSettingsFormMeta } from '@Modules/admin/integrationSettings/containers/forms/cardHolders/PersonalizationSettingsFormMeta';
import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import { BankCorporateInputs } from '../BankCorporateInputs';

type Props = {
  onSubmit: any,
  meta: IPersonalizationSettingsFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

export const PersonalizationSettingsFormUI = ({ meta, onSubmit, isLoading, isSubmitting }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors},
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema),});

  const displayCheckBoxes = (inputs: string[]) => {
    return inputs.map((input, index) => {
      return (
        <CC.Checkbox key={index} defaultChecked={index === 0} {...register(meta[input as keyof IPersonalizationSettingsFormMeta].name)}>{meta[input as keyof IPersonalizationSettingsFormMeta].label}</CC.Checkbox>
      )
    })
  }
  
  return (
    <>
      <CC.Heading as='h1' size={'md'} fontWeight="normal" mb="1%">
        Personalization Settings
      </CC.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <BankCorporateInputs register={register} hasError={errors} />
        <CC.Flex direction={{base: 'column', md: 'row'}} mt="2%">
          <CC.FormControl as='fieldset' border={'1px solid var(--chakra-colors-gray-300)'} p={5} mr={'5%'}>
            <CC.FormLabel px={2} as='legend'>
              Pré-Payé
            </CC.FormLabel>
              <CC.FormHelperText mb={'2%'}>Générer Fichier de Personnalisation Par.</CC.FormHelperText>
              <CC.Grid templateColumns={{base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'}} gap={3}>
                {displayCheckBoxes(['agencePrepaid', 'targetAudience', 'anonymousStatus'])}
              </CC.Grid>
          </CC.FormControl>
          <CC.FormControl as='fieldset' border={'1px solid var(--chakra-colors-gray-300)'} p={5}>
            <CC.FormLabel px={2} as='legend'>
              Charge / Resolving
            </CC.FormLabel>
              <CC.FormHelperText mb={'2%'}>Générer Fichier de Personnalisation Par.</CC.FormHelperText>
              <CC.Grid templateColumns={{base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'}} gap={3}>
                {displayCheckBoxes(['agenceChargeResolving', 'typeOfNetworkCard'])}
              </CC.Grid>
          </CC.FormControl>
        </CC.Flex>
        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type='submit'><FaSave style={{marginRight: '10px'}} /> Sauvegarder</CustomButton>
        </CC.Flex>
      </form>
    </>
  )
}
